// extracted by mini-css-extract-plugin
module.exports = {"container":"RecitersList_container__4Z7cE"};